import { GOOGLE_VIDEO_MIMETYPES, GOOGLE_ASSET_MIMETYPE } from "common/constants";

import BoxFilePickerDialog from "js/react/components/Dialogs/BoxFilePickerDialog";
import BynderFileImportDialog from "js/react/components/Dialogs/BynderFilePickerDialog";
import { ShowDialog, ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";
import { BoxAuthError, BoxAuthFlowWasInterruptedError } from "js/core/oauth/boxAuth";
import { FILE_TYPES } from "./PaneOptions";

/**
 * Creates Google Picker UI to display user's files
 */
export function GooglePicker(accessToken, callback, googleExtensions) {
    // We are using window within a ts file
    const firebaseConfig = (window as any).baiFirebase?.config;
    const apiKey = firebaseConfig.apiKey;
    const appId = firebaseConfig.appId;

    const google = (window as any).google;

    let view = new google.picker.View(google.picker.ViewId.DOCS);
    view.setMimeTypes([...GOOGLE_ASSET_MIMETYPE, ...GOOGLE_VIDEO_MIMETYPES].join(","));

    // by default we get all video and images
    if (googleExtensions.length === 1) {
        if (googleExtensions[0] === FILE_TYPES.IMAGE) {
            view = new google.picker.View(google.picker.ViewId.DOCS);
            view.setMimeTypes(GOOGLE_ASSET_MIMETYPE.join(","));
        }
        if (googleExtensions[0] === FILE_TYPES.VIDEO) {
            view = new google.picker.View(google.picker.ViewId.DOCS_VIDEOS);
            view.setMimeTypes(GOOGLE_VIDEO_MIMETYPES.join(","));
        }
    }

    const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .setDeveloperKey(apiKey)
        .setAppId(appId)
        .setOAuthToken(accessToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setCallback(callback)
        .build();

    return picker;
}

// Default is images
export function BoxPicker(accessToken, callback, extensions) {
    ShowDialog(BoxFilePickerDialog, {
        token: accessToken,
        extensions,
        handleSelectedFile: callback
    });
}

export function BynderPicker(callback, extensios) {
    ShowDialog(BynderFileImportDialog, { callback, extensios });
}

export function BoxErrorPicker(err) {
    if (err instanceof BoxAuthFlowWasInterruptedError) {
        ShowErrorDialog({
            title: "Error",
            message: "Oops, looks like you did not log in correctly"
        });
    } else if (err instanceof BoxAuthError) {
        ShowErrorDialog({
            title: "Oops, something went wrong!",
            message: err.message
        });
    } else {
        ShowErrorDialog({
            title: "Error",
            message: "Sorry, we could not process your request, try another one or contact support at support@beautiful.ai"
        });
    }
}

